import { jsx } from "react/jsx-runtime";
import AntForm from "antd/es/form";
import classnames from "../../utils/classnames.js";
import InternalFormItem from "./FormItem.js";
import './Form.css';/* empty css          */
const InternalForm = function Form({ className, layout = "vertical", ...props }) {
  return /* @__PURE__ */ jsx(AntForm, { layout, className: classnames("perxis-auto-form", className), ...props });
};
const Form2 = InternalForm;
Form2.Item = InternalFormItem;
Form2.Provider = AntForm.Provider;
Form2.ErrorList = AntForm.ErrorList;
Form2.List = AntForm.List;
Form2.useForm = AntForm.useForm;
Form2.useFormInstance = AntForm.useFormInstance;
Form2.useWatch = AntForm.useWatch;
export {
  Form2 as default
};
//# sourceMappingURL=Form.js.map
